// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import {
  JS_API_PRIVACY_COOKIE_NAME,
  isNonCookieConsentSource,
} from 'app/components/analytics-builder/CONSENT_SOURCE_TYPES';

export const DEFAULT_BULK_COOKIE_NAME = 'mr_consent';

/**
 * Copy the stored consent source columns onto a consent block.
 *
 * Shared by the bulk rebuild and the bulk YAML download so the two cannot
 * disagree about a pipeline's consent configuration: a download that omits
 * these fields round-trips back through bulk upload as NULL columns, which
 * silently converts a jsApi pipeline to a cookie source.
 *
 * @param {object} consent - Consent block to extend, mutated in place
 * @param {object} settings - Stored analytics_file_settings row
 * @returns {object} The same consent block
 */
export default function applyStoredConsentSource(consent, settings) {
  if (settings?.consentSource) {
    consent.consentSource = settings.consentSource;
  } else {
    // A NULL source derives from cookieName, but its independently stored options may still be populated.
    consent.cookieName = settings?.cookieName ?? DEFAULT_BULK_COOKIE_NAME;
  }

  if (settings?.globalPrivacyControl || settings?.consentSource) {
    consent.globalPrivacyControl = settings.globalPrivacyControl ?? { enabled: false, codes: [] };
  }
  if (Array.isArray(settings?.optInValues)) {
    consent.optInValues = settings.optInValues;
  }
  return consent;
}

/**
 * The cookieName the legacy `privacy` block must carry. builder-server hard-
 * validates that block whenever it is present (getPrivacySettings throws on a
 * falsy cookieName), so jsApi sources send a placeholder; the consent module
 * drives the actual decisions.
 *
 * @param {object} settings - Stored analytics_file_settings row
 * @returns {string} Cookie name for the privacy block
 */
export function resolvePrivacyCookieName(settings) {
  if (isNonCookieConsentSource(settings?.consentSource?.type)) {
    return JS_API_PRIVACY_COOKIE_NAME;
  }
  return settings?.cookieName ?? DEFAULT_BULK_COOKIE_NAME;
}
